import alt from "../alt";
import indexBy from "lodash/keyBy";
import moment from "moment";

import ShiftUtil from "../utils/ShiftUtil";
import ShiftActions from "../actions/ShiftActions";
import UserStore from "../stores/UserStore";

import config from "../config";

class ShiftStore {
  constructor() {
    this.bindActions(ShiftActions);

    this.state = {
      isWorking: true,
      hasFetchedForFirstTime: false,
      currentShift: null
    };
  }

  onReset() {
    this.setState({
      isWorking: true,
      hasFetchedForFirstTime: false,
      currentShift: null
    });
  }

  onFetchCurrentShift() {
    this.setState({ isWorking: true });

    ShiftUtil.fetchCurrentShift(UserStore.getState().apiKey)
      .then(data => {
        this.setState({ currentShift: data });
      })
      .catch(() => {
        /* Fall through - no current shift */
      })
      .finally(() => {
        this.setState({ isWorking: false, hasFetchedForFirstTime: true });
      });
  }

  onCreateShift(data) {
    this.setState({ isWorking: true });

    ShiftUtil.createShift(UserStore.getState().apiKey, data)
      .then(shift => {
        this.setState({ currentShift: shift });
      })
      .catch(e => {
        alert(`Failed to start new shift: ${e.message}`);
      })
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }

  onCloseShift(data) {
    this.setState({ isWorking: true });

    const shiftId = this.state.currentShift.id;

    ShiftUtil.closeShift(UserStore.getState().apiKey, data)
      .then(() => {
        window.open(
          `${
            config.endpoint
          }shifts/${shiftId}/receipt.pdf?${UserStore.makeApiKeyQueryString()}&tz=${moment.tz.guess()}`
        ); // open cash out receipt
        this.setState({ currentShift: null });
      })
      .catch(e => {
        alert(`Failed to close shift: ${e.message}`);
      })
      .finally(() => {
        this.setState({ isWorking: false });
      });
  }
}

export default alt.createStore(ShiftStore, "ShiftStore");



// WEBPACK FOOTER //
// ./src/app/stores/ShiftStore.js